import React from 'react';
import { connect } from 'react-redux';
import { Flex } from '@leverege/ui-elements';
import { UserSettings } from '@leverege/ui-redux';
import { Toolbar, OkayCancelEditor, TitleBar } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import S from './ExportSettingsEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.actions.ExportSettingsEditor');
class ExportSettingsEditor extends React.Component {
  static defaultProps = {
    get okayLabel() {
      return t('okayLabel');
    },
    get cancelLabel() {
      return t('cancelLabel');
    },
    closeOnSave: true,
    get titleIcon() {
      return tIcon('titleIcon', 'fa fa-cog fa-fw');
    },
    titleVariant: 'dialogTitle',
    simple: false,
    handleSave: true,
    onSave: () => {},
    onClose: () => {},
    variant: null,
    editorProps: {},
    applyOnChange: false,
    get title() {
      return t('title');
    }
  };
  onSave = evt => {
    const {
      onSave
    } = this.props;
    if (onSave) {
      onSave(evt);
    }
  };
  onClose = e => {
    const {
      onClose
    } = this.props;
    if (onClose) {
      onClose(e);
    }
  };
  getContext(editor, value, original) {
    const {
      settingsPath,
      versionsPath,
      variant,
      simple
    } = this.props;
    return {
      value,
      original,
      variant,
      settingsPath,
      versionsPath,
      onClose: this.onClose,
      editor,
      clientProps: this.props,
      simple
    };
  }
  renderTitle = (value, original, variant, editor) => {
    const {
      title,
      settingsPath,
      titleIcon,
      versionsPath,
      titleVariant,
      simple
    } = this.props;
    // can call editor.onChange
    const context = this.getContext(editor, value, original);
    return /*#__PURE__*/_jsx("div", {
      className: S.fullWidth,
      children: /*#__PURE__*/_jsxs(TitleBar, {
        variant: titleVariant,
        title: title,
        icon: titleIcon,
        children: [/*#__PURE__*/_jsx(Flex, {
          align: "center",
          children: /*#__PURE__*/_jsx(Toolbar, {
            variant: "actionBar",
            matchContext: {
              use: 'titleLeft',
              client: 'ExportSettingsEditor',
              settingsPath,
              versionsPath
            },
            prefer: simple ? 'icon' : null,
            context: context
          })
        }), /*#__PURE__*/_jsx(Toolbar, {
          variant: "actionBar",
          matchContext: {
            use: 'titleRight',
            client: 'ExportSettingsEditor',
            settingsPath,
            versionsPath
          },
          prefer: simple ? 'icon' : null,
          context: context
        })]
      })
    });
  };
  render() {
    const {
      editorProps,
      editor,
      value,
      simple,
      okayLabel,
      cancelLabel
    } = this.props;
    return /*#__PURE__*/_jsx(OkayCancelEditor, {
      style: simple ? {
        '--size-editorMinHeight': 'auto',
        '--size-editorMinWidth': 'auto',
        minWidth: 'auto'
      } : undefined,
      alwaysEnableSave: true,
      okayLabel: okayLabel,
      cancelLabel: cancelLabel,
      onChange: this.onSave,
      onCancel: this.onClose,
      title: this.renderTitle,
      value: value,
      editor: editor,
      editorProps: {
        ...editorProps,
        advanced: !simple
      }
    });
  }
}
export default connect((state, props) => {
  const {
    settingsPath
  } = props;
  return {
    value: props?.value || UserSettings.get(state, settingsPath, {
      returnPromise: false
    })
  };
})(ExportSettingsEditor);